export default __webpack_public_path__ + "static/media/check.0bd82e56.png";